import * as Interfaces from 'interfaces';
import { transformMobileInt } from '../../utils/validations';

export function getStreetAddress(fullAddress?: string): string {
  if (!fullAddress) return '';
  if (!fullAddress.includes(',')) return fullAddress;
  const strAddress: string[] = fullAddress.split(',');
  strAddress.splice(strAddress?.length - 1, 1);
  return strAddress.join(',');
}

export function serializeForm(values: Interfaces.Common.FormValues, transactionId: string) {
  const {
    identity: { proofType, middleName, phone, address, isAddressValidated, ...core }
  } = values;
  const addressValidated = !!address.fullDetails.id;

  return {
    ...core,
    proofType,
    ...(proofType === 'licence' ? { middleName } : {}),
    phone: transformMobileInt(phone),
    homeAddress: JSON.stringify(address.fullDetails),
    isAddressValidated: addressValidated,
    transactionId
  };
}
